/* eslint-disable @typescript-eslint/no-shadow  */
// Dialer calls for review (BIO-2492). The API stores one record per Dialpad
// call with the recording, transcript, AI summary and the rep's wrap-up.
// Transcripts and notes are customer conversations: never log them.
export const PAGE_SIZE = 25;

export const state = () => ({
  calls: [],
  total: 0,
  loading: false,
  // Set by the API: only one person per environment may see inbound calls.
  canViewInbound: false,
});

export const mutations = {
  setCalls(state, { calls, total }) {
    state.calls = calls;
    state.total = total;
  },

  setCanViewInbound(state, canViewInbound) {
    state.canViewInbound = !!canViewInbound;
  },

  setLoading(state, loading) {
    state.loading = loading;
  },
};

// Drops empty filters so the query string only carries what's set.
export function callsQuery(filters = {}) {
  return Object.keys(filters).reduce((query, key) => {
    const value = filters[key];

    if (value !== null && value !== undefined && value !== '') {
      query[key] = value;
    }

    return query;
  }, {});
}

export const actions = {
  // One page of calls, without touching the store.
  async findCalls(_context, filters = {}) {
    const { data } = await this.$axios.get('/calls', {
      params: callsQuery({
        limit: PAGE_SIZE,
        ...filters,
      }),
    });

    return data;
  },

  async fetchCalls({ commit, dispatch }, filters = {}) {
    commit('setLoading', true);

    try {
      const data = await dispatch('findCalls', filters);

      commit('setCalls', {
        calls: data.calls || [],
        total: data.total || 0,
      });
      commit('setCanViewInbound', data.canViewInbound);

      return data;
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchCall(_context, id) {
    const { data } = await this.$axios.get(`/calls/${id}`);

    return data;
  },

  // Loads the audio through our API with the admin's session, so the browser
  // never sees a Dialpad link. Resolves to null when there's no recording.
  async fetchRecording(_context, id) {
    try {
      const { data } = await this.$axios.get(`/calls/${id}/recording`, {
        responseType: 'blob',
      });

      return data;
    } catch (err) {
      if (err && err.response && err.response.status === 404) {
        return null;
      }

      throw err;
    }
  },
};
